import { Component, Input, OnInit } from '@angular/core';
import { PageElementSpec } from '../../../classes/page-element-spec';

@Component({
    selector: 'app-page-element',
    standalone: true,
    imports: [],
    templateUrl: './dynamic-page-element.component.html',
    styleUrl: './dynamic-page-element.component.css'
})
export class DynamicPageElementComponent {

  @Input() pageElement: PageElementSpec<string>;
  // @Input() pageElement!: any;

  constructor() {
    this.pageElement = new PageElementSpec();
  }

  ngOnInit() {
  }

}
